import { getServiceName } from '@repo/utils';

import BubblechatUniverseIcon from './BubblechatUniverseIcon';
import TingleUniverseIcon from './TingleUniverseIcon';
import { IConDefaultType } from '../..';

export enum UniverseIconVariant {
  DEFAULT = 'default',
  CARTOON = 'cartoon',
}

export type IUniverseIconProps = IConDefaultType & {
  variant?: UniverseIconVariant;
};

const UniverseIcon = (props: IUniverseIconProps) => {
  const serviceName = getServiceName();
  switch (serviceName) {
    case 'tingle':
      return <TingleUniverseIcon {...props} />;
    default:
      return <BubblechatUniverseIcon {...props} />;
  }
};

export default UniverseIcon;
